import React from "react";
import { Tooltip, Button } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import "./floatingWhatsApp.css";

const FloatingWhatsApp = () => {
  return (
    <div className="floating-whatsapp-container">
      <Tooltip title="Chat on WhatsApp" placement="left">
        <a
          href="https://wa.me/+045771575"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            type="primary"
            shape="circle"
            icon={<WhatsAppOutlined />}
            size="large"
            style={{
              backgroundColor: "#25D366",
              borderColor: "#25D366",
              fontSize: "30px",
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </a>
      </Tooltip>
    </div>
  );
};

export default FloatingWhatsApp;